import type { Cart } from 'src/app/v1/state/types/cart';
import { mapCartLineItemToOrderLineItem } from 'src/app/v1/views/hooks/useCreateOrderWithProductSet/mappers';

export const getCreateFlowOrderJobId = (cart: Cart): string | undefined => {
  const orderLineItems = cart.lineItems
    .filter((item) => item.type === 'AdProduct')
    .map(mapCartLineItemToOrderLineItem);
  const orderJobId =
    orderLineItems[0]?.productAttributes.catalogueProduct?.jobId;

  return orderJobId || undefined;
};
